import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useData } from '@hooks/useData';

const ENDPOINT_URL = '/two-factor-auth/generate';
const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type Google2FAQrCodeInput = paths[url]['post']['requestBody']['content']['application/json'];

export interface google2FAQrCodeSuccessResponse {
    data: paths[url]['post']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to register a new user account.
 */
export const useGoogle2FAQrCode = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setQrCode } = useData();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const request = async (props: Google2FAQrCodeInput) => {
        setLoading(true);
        setError(null);



        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(props),
            });

            const data: google2FAQrCodeSuccessResponse = await response.json();

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.message || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            setQrCode(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime };
};
